
interface TestimonialCardProps {
  name: string;
  location: string;
  rating: number;
  comment: string;
}

export default function TestimonialCard({ name, location, rating, comment }: TestimonialCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
      <div className="flex items-center mb-4">
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
          <i className="ri-user-line text-green-600 text-xl"></i>
        </div>
        <div>
          <h4 className="font-semibold text-gray-800">{name}</h4>
          <p className="text-sm text-gray-600">{location}</p>
        </div>
      </div>
      <div className="flex mb-3">
        {[...Array(5)].map((_, i) => (
          <i 
            key={i} 
            className={`ri-star-${i < rating ? 'fill' : 'line'} text-yellow-400`}
          ></i>
        ))}
      </div>
      <p className="text-gray-700 italic">"{comment}"</p>
    </div>
  );
}
